import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsCamera, BsTrash } from 'react-icons/bs';

import ButtonWithIcon from '../ButtonWithIcon';
import { SNAPSHOT_STATUS } from '../../utils/snapshotStatus';

const SnapshotButton = ({ snapshotStatus, onTakeSnapshot, onDeleteSnapshot }) => {
  const isSnapshotting = snapshotStatus === SNAPSHOT_STATUS.SNAPSHOTTING;
  const isTaken = snapshotStatus === SNAPSHOT_STATUS.TAKEN;

  const getTooltip = () => {
    if (isSnapshotting) return 'Snapshotting...';
    if (isTaken) return 'Delete Snapshot';
    return 'Take Snapshot';
  };

  const getVariant = () => {
    if (isSnapshotting) return 'info';
    if (isTaken) return 'danger';
    return 'success';
  };

  const handleClick = isTaken ? onDeleteSnapshot : onTakeSnapshot;

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{getTooltip()}</Tooltip>}
    >
      <div>
        <ButtonWithIcon
          Icon={isTaken ? <BsTrash /> : <BsCamera />}
          size="sm"
          variant={getVariant()}
          onClick={handleClick}
          disabled={isSnapshotting}
          style={{ height: '30px' }}
        />
      </div>
    </OverlayTrigger>
  );
};

SnapshotButton.propTypes = {
  snapshotStatus: PropTypes.string.isRequired,
  onTakeSnapshot: PropTypes.func.isRequired,
  onDeleteSnapshot: PropTypes.func.isRequired,
};

export default SnapshotButton;
